import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useRef, useState } from "react";
import TableEmptyState from '../ReusableComponents/TableEmptyState';
import SweetAlert from "react-bootstrap-sweetalert";
import { FaListAlt, FaVideo } from "react-icons/fa";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";



const CandidatosConflitos = (props) => {const { t } = usePreferences();

  const [lesson_cards, SetLessonCards] = useState(null);
  const [loading_screen, setLoadingScreen] = useState(true);
  const [loading_candidatos, setLoadingcandidatos] = useState(false);
  const [search_oficial, setSearchOficial] = useState('');

  const [candidatos, setcandidatos] = useState([]);
  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



  const [search, setSearch] = useState('');
  const { faculdade_id, faculdade_name } = props;
  const [show_warning, setShowWarning] = useState(false);
  const [candidato_id, setcandidatoId] = useState(null);


  const [questaoSelect, setQuestaoSelect] = useState({});

  const [showModal, setShowModal] = useState(false);
  let refs = [];
  const dispatch = useDispatch();

  const Getcandidatos = async (page, search) => {

    let response = await Request.Get(`faculdade/get_candidatos_errors/${faculdade_id}?page=${page}&search=${search}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    if (response.pagination.current_page == page) {

      setcandidatos(response.alunos);

      setPagination(response.pagination);
      setLoadingScreen(false);
      setLoadingcandidatos(false);


    }
  };

  const Deletecandidato = async (candidato_id) => {

    let response = await Request.Delete(`faculdade/delete_candidato_error/${candidato_id}`);
    console.log(response);
    if (response === undefined) return;

    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    Getcandidatos(pagination.current_page, search_oficial);



  };

  useEffect(() => {
    Getcandidatos(1, search_oficial);
  }, []);

  let pesquisarTimeout = null;
  const history = useHistory();
  return (
    <div className="row">

            <div className="col-12">


                {/* <hr /> */}
                {loading_screen == false && <div>
                <p className="text-muted">{t("legacy_aqui_ficam_os_candidatos_que_possuem_conflito_de_cpf_com_outros_candid")}</p>

                    {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                    {/* <br /> */}

                    <div className="flex jcsb flex-wrap mb-4">

                        <Search placeholder={t("legacy_pesquisar_pelo_nome_do_candidato")} ValueChange={(value) => {
              clearTimeout(pesquisarTimeout);
              setSearchOficial(value);

              pesquisarTimeout = setTimeout(() => {
                let page = { ...pagination };
                page.current_page = 1;
                setPagination(pagination);
                setLoadingcandidatos(true);

                Getcandidatos(1, value);

              }, 500);
            }} />


                    </div>

                    <div className="table-modern-card">
                        <div className="table-modern-scroll mb-0">
                            <table id="tech-companies-1" className="table table-striped">
                                <thead>
                                    <tr>

                                        <th>{t("label_name")}</th>
                                        <th>{t("label_email")}</th>
                                        <th>{t("legacy_cpf")}</th>
                                        <th>{t("legacy_data_de_nascimento")}</th>
                                        <th data-priority="3">{t("label_actions")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading_candidatos == false && candidatos.map((item, id) =>

                  <tr key={id}>
                                            <td>{item.name}</td>
                                            <td>{item.email}</td>
                                            <td>{item.cpf}</td>

                                            <td>{moment(item.nascimento, 'YYYY-MM-DD').format('DD/MM/YYYY')}</td>

                                            <td>
                                                <div className="actions-group">
                                                {/* <span
                        onClick={() => {
                        }}
                        className="inline-flex align-center jcc bg-warning icon"
                        style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                        title="Gerenciar candidato"
                        >
                        <BsFillEyeFill size={17} color="white" />
                        </span> */
                      }
                                                <Link to={`/candidatos_errors/edit/${item.id}`} onClick={(e) => e.stopPropagation()}>
                                                    <span
                          className="inline-flex align-center jcc bg-info icon"
                          style={{ width: "2em", height: "2em", borderRadius: "7px", marginRight: "2px", marginLeft: "2px" }}
                          data-toggle="tooltip"
                          title={t("ui_alterar_questao_bbfea6ad")}>

                                                    <BsFillEyeFill size={17} color="white" />
                                                    </span>
                                                </Link>
                                                <span
                        onClick={(e) => {
                          setcandidatoId(item.id);
                          setShowWarning(true);
                          e.stopPropagation();
                        }}
                        className="inline-flex align-center jcc bg-danger icon"
                        style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                        title="Deletar candidato">

                                                    <MdDelete size={17} color="white" />
                                                </span>

                                                </div>
                                                </td>

                                        </tr>
                  )}

                                </tbody>
                            </table>
                            {loading_candidatos == true &&
              <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                    {/* <div className="spinner-border text-primary" role="status"  >
                    </div> */}
                                    <CircularProgress />
                                </div></div>

              }
                        </div>
                    </div>
                    {loading_candidatos == false && candidatos.length == 0 && <div className="row">
                        <div className="col-12">
                            <TableEmptyState title={t("empty_no_candidate_found")} icon="👤" />

                        </div>
                    </div>}

                    <Pagination
            className={pagination.last_page == 1 ? "hide" : ""}
            style={{ display: "flex", justifyContent: "flex-end" }}
            count={pagination.last_page}
            value={pagination.current_page}
            onChange={(_, value) => {
              setLoadingcandidatos(true);
              console.log(_, value);
              let page = { ...pagination };
              page.current_page = value;
              setPagination(pagination);
              Getcandidatos(value, search_oficial);
            }} />


                    {/* {this.state.andamento == true && <AvaliacaoAndamento get_candidato={this.get_candidato.bind(this)} {...this.props} />} */}

                </div>}

                {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    {/* <div className="spinner-border text-primary" role="status"  >
              </div> */}
                    <CircularProgress />
                </div></div>}

                <SweetAlert
          warning
          title={t("legacy_atencao")}
          onConfirm={() => {
            setShowWarning(false);
            setLoadingcandidatos(true);
            Deletecandidato(candidato_id);
            // this.delete_banner(this.state.banner_to_delete);
          }}
          onCancel={() => {
            setShowWarning(false);
          }}
          show={show_warning}
          confirmBtnText={t("legacy_sim_desejo_apagar")}
          cancelBtnText={t("legacy_cancelar")}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          showCancel={true}>{t("ui_ao_deletar_este_candidato_ele_nao_estara_mais_disp_014976fb")}


        </SweetAlert>


            </div>

        </div>);

};

export default CandidatosConflitos;